import React from 'react';
import {observer, inject} from 'mobx-react';
import {cmURL} from '../../libs/config'

@inject('contentStore')
@observer
class Notice extends React.Component {
  render() {
    let notice = this.props.contentStore.notice;
    return (
      <div>{notice.length > 0 &&
        notice.map((item, index) => (
          <p key={index}><a href={`${cmURL}/files/${item.file_name}`} target="_blank" rel="noopener noreferrer">{item.title}</a></p>
        ))
      }</div>
    );
  }
}

export default Notice;


// WEBPACK FOOTER //
// ./src/components/Home/Notice.js